import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/coghent.svg'


const _withScopeId = n => (_pushScopeId("data-v-12b0544a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "modals" }, null, -1))
const _hoisted_2 = { class: "bg-background-light font-body pt-6 flex flex-col items-center overflow-x-hidden relative" }
const _hoisted_3 = { class: "container min-h-screen" }
const _hoisted_4 = {
  key: 0,
  class: "fixed bottom-0 w-full z-50"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  href: "logo"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_header = _resolveComponent("the-header")!
  const _component_notification = _resolveComponent("notification")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_mobile_menu = _resolveComponent("mobile-menu")!
  const _component_offensive_content_modal = _resolveComponent("offensive-content-modal")!
  const _component_details_modal = _resolveComponent("details-modal")!
  const _component_creative_modal = _resolveComponent("creative-modal")!
  const _component_disclaimer_button = _resolveComponent("disclaimer-button")!
  const _component_disclaimer_pop_up = _resolveComponent("disclaimer-pop-up")!
  const _component_onBoardingCarousel = _resolveComponent("onBoardingCarousel")!
  const _component_the_footer = _resolveComponent("the-footer")!
  const _component_OnScreenKeyboard = _resolveComponent("OnScreenKeyboard")!
  const _component_CookiePreferencesModal = _resolveComponent("CookiePreferencesModal")!
  const _component_MinimalCookieConsent = _resolveComponent("MinimalCookieConsent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_header, {
          onIsOpen: _cache[0] || (_cache[0] = (status) => (_ctx.mobileMenuIsOpen = status))
        }),
        _createVNode(_component_notification),
        _createVNode(_component_router_view),
        _createVNode(_Transition, { name: "menu" }, {
          default: _withCtx(() => [
            (_ctx.mobileMenuIsOpen === true)
              ? (_openBlock(), _createBlock(_component_mobile_menu, {
                  key: 0,
                  onIsOpen: _cache[1] || (_cache[1] = (status) => (_ctx.mobileMenuIsOpen = status))
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_offensive_content_modal),
        _createVNode(_component_details_modal),
        _createVNode(_component_creative_modal),
        (!_ctx.route.query.touch)
          ? (_openBlock(), _createBlock(_component_disclaimer_button, { key: 0 }))
          : _createCommentVNode("", true),
        (!_ctx.route.query.touch)
          ? (_openBlock(), _createBlock(_component_disclaimer_pop_up, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.onboardingState.onboardingShown)
          ? (_openBlock(), _createBlock(_component_onBoardingCarousel, { key: 2 }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_the_footer),
      _createVNode(_Transition, { name: "keyboard" }, {
        default: _withCtx(() => [
          (_ctx.route.query.touch && _ctx.keyboardState.state === 'shown')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_OnScreenKeyboard)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.route.query.touch)
        ? (_openBlock(), _createBlock(_component_CookiePreferencesModal, {
            key: 0,
            preferenceModalTitle: _ctx.t('main.cookieConsent.preferenceModalTitle')
          }, {
            logo: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["preferenceModalTitle"]))
        : _createCommentVNode("", true),
      (!_ctx.route.query.touch)
        ? (_openBlock(), _createBlock(_component_MinimalCookieConsent, {
            key: 1,
            minimalCookieConsentTitle: _ctx.t('main.cookieConsent.title'),
            minimalCookieConsentDescription: _ctx.t('main.cookieConsent.description'),
            acceptText: _ctx.t('main.cookieConsent.accept'),
            preferencesText: _ctx.t('main.cookieConsent.preferences')
          }, null, 8, ["minimalCookieConsentTitle", "minimalCookieConsentDescription", "acceptText", "preferencesText"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}